import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import Datepicker from 'vuejs-datepicker';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
import CandidateService from '@/core/services/candidate.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    Datepicker,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditEvaluatedComponent extends Vue {

  candidateService: any = new CandidateService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  candidateList: any = [];
  companyList: any = [];
  reporterList: any = [];
  jobList: any = [];
  name: string = "";
  surname: string = "";
  birthdate: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  country: string = "";
  companies: string = "";
  jobs: string = "defaultJob";
  job: string = "";
  reporters: string = "defaultReporters";
  reporter: string = "";
  manuallyPassword: boolean = false;
  isTrainingSuperAdmin: boolean = false;
  
  mounted (){
    const _ = this;
    _.isTrainingAdmin();
    _.getById();
    _.getCompanies();
    _.getJobs();
    _.getReporters();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  getCompanies(){
    const _ = this;
    _.isLoading = true;
    _.candidateService.getCompanies().then((data: any) => {
      _.companyList = data['data'].companies;
      _.companyList.sort(function(a, b) {
        var textA = a.name.toLowerCase();
        var textB = b.name.toLowerCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      _.isLoading = false;
    })
  }

  getReporters(){
    const _ = this;
    _.isLoading = true;
    _.candidateService.getReporters().then((data: any) => {
      _.reporterList = data['data'].reporters;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  getJobs(){
    const _ = this;
    _.isLoading = true;
    _.candidateService.getJobs().then((data: any) => {
      _.jobList = data['data'].jobs;
      console.log(data);
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      _.isLoading = false;
    })
  }

  edit(){
    const _ = this;
    let user = {
      name: _.name,
      surname: _.surname,
      birthdate: _.birthdate,
      email: _.email,
      jobId: _.jobs,
      companyId: _.companies,
      reporterId: _.reporters,
    };
    console.log(_.password, 'jaja');
    let userId: any = location.href.split("/");
    userId = userId[5];
    if(_.manuallyPassword){
      user.password = _.password;
      user.confirm_password = _.confirm_password;
      if(_.password == ''){
        _.genericErr.push("La contraseña es necesaria");
        return;
      }
      if(_.password.length < 6 && _.password != ''){
        _.genericErr.push("La constraseña debe tener minimo 6 caracteres");
        return;
      }
      if(_.password != _.confirm_password ){
        _.genericErr.push("Las constraseñas no coinciden");
        return;
      }
    }
    _.isLoading = true;
    _.candidateService.edit(user, userId).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/evaluated');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let userId: any = location.href.split("/");
    userId = userId[5];
    _.isLoading = true;
    _.candidateService.getById(userId).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].user.name;
      _.surname = data["data"].user.surname;
      _.birthdate = data["data"].user.birthdate;
      _.email = data["data"].user.email;
      _.companies = data["data"].user.companyId;
      _.jobs = data["data"].user.jobId;
      _.reporters = data["data"].user.reporterId;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(email = '', companies = '', jobs = 'defaultJob', reporters = 'defaultReporters'){
    const _ = this;
    _.genericErr = [];
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email == ''){
      _.genericErr.push("Por favor escribe un correo");
    }
    if(companies == ''){
      _.genericErr.push("Por favor selecciona una compañía");
    }
    if(jobs == 'defaultJob'){
      _.genericErr.push("Por favor selecciona un puesto");
    }
    if(reporters == 'defaultReporters'){
      _.genericErr.push("Por favor selecciona un reporteador");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }
}
